import React from "react";

import closeIcon from "../../../../assets/icons/close.svg";
const ViewTemplateHeader = (props) => {
  return (
    <div className="header d-flex">
      <div className="is-size-h4">Document View</div>
      <div className="ml-auto close" onClick={props.templateViewCloseHandler}>
        <img src={closeIcon} alt="close" />
      </div>
    </div>
  );
};

export default ViewTemplateHeader;
